<template>
  <el-row type="flex"
          class="tab-container">
    <div class="tab-item"
         v-for="item in softTypeList"
         :class="[item.id === activeTabId ? 'active' : '', isRunning ? 'tab-disabled' : '']"
         :key="item.id"
         @click="handleActive(item)">
      <img src="~assets/pics/license.png"
           v-if="item.name===languages.softInstall.license"
           alt="">
      {{ item.name }}
    </div>
  </el-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  inject: ['homeTemplate'],
  data () {
    return {
      activeId: '',
      pvId: '',
    };
  },
  computed: {
    ...mapState(['softTypeList', 'activeTabId', 'selectSoftDetails', 'isRunning', 'languages']),
  },
  methods: {
    ...mapMutations([
      'setSoftSearch', 'setSoftTabPage', 'setSelectSoftDetails', 'setFooterWarn', 'setAuthTap', 'setPvId',
    ]),
    handleActive (item) {
      this.saveUbt(item);
      const { id, name } = item;
      if (name === this.languages.softInstall.license) {
        this.setFooterWarn(this.languages.softInstall.applyWarn);
      } else {
        this.setFooterWarn('');
      }
      const status = name === this.languages.softInstall.license;
      this.setAuthTap(status);

      if (id === this.activeId) return;
      this.activeId = id;
      this.setSoftSearch('');
      if (!this.isRunning) {
        this.setSoftTabPage(id);
        this.setSelectSoftDetails(id);
        this.homeTemplate.checkUninstallResult();
      }
    },
    saveUbt(item) {
      ubtSendTrace(245278, 'sw_install', 'tag_click', item.name, item.id, '', this.pvId);
    },
  },
  created () {
    this.pvId = ubtRegister('Install');
    this.setPvId(this.pvId);
  },
};
</script>

<style lang="scss" scoped>
.tab-container {
  flex-wrap: wrap;
  margin: 11px 0 5px 0;
  .tab-item {
    margin-left: 5px;
    width: 85px;
    height: 28px;
    line-height: 28px;
    padding: 0;
    margin-bottom: 5px;
    font-size: 14px;
    text-align: center;
    border: 1px solid #e9e9eb;
    border-radius: 5px;
    background-color: #f4f4f5;
    color: #909399;
    cursor: pointer;
    img {
      margin: 0 -3px -3px -2px;
      height: 18px;
    }
  }
  .active {
    // font-weight: bolder;
    color: #000;
    background-color: #e0e0e0;
  }
  .tab-disabled {
    cursor: not-allowed;
  }
}
</style>
